import L from "leaflet";
import 'leaflet/dist/leaflet.css';
import FilterTags from "./filter-tags";
import stateData from "../map/bundeslaender";

class Map {
    init() {
        this.$map = $("#map");

        if (!this.$map.length) {
            return;
        }

        this.$loader = this.$map.find("#map-loading");

        // init map itself
        this.map = L.map('map', {
            attributionControl: false,
            scrollWheelZoom: false,
            zoomSnap: 0.5,
            minZoom: 5.5
        })
        .setView([51.505, 10.5], 5.5);

        let bonds = this.map.getBounds();
        let corner1 = [bonds.getNorthWest().lat+0.01, bonds.getNorthWest().lng+0.01]
        let corner2 = [bonds.getSouthEast().lat+0.01, bonds.getSouthEast().lng+0.01]

        this.map.setMaxBounds([corner1, corner2]);

        this.markerLayer = L.layerGroup();
        this.markerLayer.addTo(this.map);

        this.initMapSwitch();
        this.loadTiles();
        this.initInitiativeMarkers();
    }

    initDefaultMapData(fit = false) {
        let url = this.$map.attr('data-default-map-data-url');

        if (this.defaultData) {
            this.markerLayer.clearLayers();
            this.drawDefaultMarkers(this.defaultData, fit);
        }
        else {
            $.get(url, (data) => {
                this.defaultData = data;
                this.drawDefaultMarkers(data, fit);
            });
        }
    }

   drawDefaultMarkers(data, fit = false) {
       let myIcon = L.divIcon({popupAnchor: [0, -30]});

       this.$loader.show();

       $(data).each((index, obj) => {
           let marker = L.circleMarker([obj.lat, obj.long]
               , {
                   radius: 19,
                   fillColor: "#336699",
                   color: "#996633",
                   weight: 1,
                   opacity: 0.8,
                   fillOpacity: 0.8,
                   className: "hover-transparency cs-overview",
                   icon: myIcon
               }
           );

           L.tooltip({
               permanent: true,
               direction: 'center',
               className: 'text-inplace'
           })
           .setContent(obj.initiative_count.toString())
           .setLatLng([obj.lat, obj.long])
           .addTo(this.markerLayer);

           let title = 'Zeige Begehren aus ' + obj.land_name;

           marker.bindPopup('<a href="' + obj.link + '" title="' + title + '">' + obj.land_name + '</a>');
           marker.addTo(this.markerLayer);
       });

       this.insertStateBorders();

       if (fit) {
           this.map.setView([51.505, 10.5], 5.5);
       }

       this.$loader.hide();
    }

    insertStateBorders() {
        let style = feature => {
            let total = 0;
            let own = 0;

            for (let land of this.defaultData) {
                total += parseInt(land['initiative_count']);

                if (land['land_abbr'] === feature.properties['ABBR']) {
                    own = parseInt(land['initiative_count']);
                }
            }

            let opacity = (own/total) * 3.5;

            if (opacity > 0.55) {
                opacity = 0.55;
            }
            return {
                fillColor: '#004213',
                fillOpacity: opacity,
                weight: 0
            };
        };

        if (!this.stateLayer) {
            this.stateLayer = L.geoJson(stateData, {style: style});
        }

        this.stateLayer.addTo(this.map);
    }

    initMapSwitch() {
        let $map = this.$map;

        $('#map-switch input').on('change', function () {
            if (this.checked) {
                $map.show();
            } else {
                $map.hide();
            }
        });
    }

    loadTiles() {
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 12,
            id: 'mapbox',
            attribution: 'test',
        }).addTo(this.map);
    }

    initInitiativeMarkers() {
        this.map.on('moveend', () => {
            if (this.firstMove && !this.cancelMoveEvent && !this.popupClick) {
                this.drawMarkers(false, true);
            }
            else {
                this.firstMove = true;
                this.cancelMoveEvent = false;
            }
        });
    }

    drawMarkers(fit = false, sendBBox = false) {
        let filtered = this.$map.attr("data-filtered") === 'true';

        if (this.map.getZoom() < 7 && !fit && !filtered) {
            this.initDefaultMapData();
            return;
        }

        this.popupClick = false;

        this.$loader.show();

        if (this.stateLayer) {
            this.stateLayer.removeFrom(this.map);
        }

        let url = this.$map.attr('data-map-data-url');

        let data = {};

        if (sendBBox) {
            let bounds = this.map.getBounds();

            data = {
                'top_left_lat': bounds.getNorthWest().lat,
                'top_left_lon': bounds.getNorthWest().lng,
                'bottom_right_lat': bounds.getSouthEast().lat,
                'bottom_right_lon': bounds.getSouthEast().lng,
            };
        }

        let markerMap = {};

        $.get(url, data, (data) => {
            if (!data || Array.isArray(data) && data.length === 0) {
                this.initDefaultMapData(true);
            }

            this.markerLayer.clearLayers();
            let myIcon = L.divIcon({popupAnchor: [0, -30]});
            let group = L.featureGroup();

            $(data).each((index, obj) => {
                if (markerMap["" + obj.lat + obj.long]) {
                    let marker = markerMap["" + obj.lat + obj.long];
                    marker.bindPopup(this.getMarkerText(obj, marker._popup._content), {
                        maxHeight: '300'
                    });
                }
                else {
                    let marker = L.circleMarker([obj.lat, obj.long]
                        , {
                            radius: 4,
                            fillColor: "#336699",
                            color: "#996633",
                            weight: 1,
                            opacity: 0.8,
                            fillOpacity: 0.8,
                            className: "hover-transparency cs-overview",
                            icon: myIcon
                        }
                    );

                    markerMap["" + obj.lat + obj.long] = marker;

                    marker.bindPopup(this.getMarkerText(obj), {
                        maxHeight: '300'
                    });
                    marker.addTo(this.markerLayer);

                    marker.on("popupopen", () => {
                        this.popupClick = true;
                        window.setTimeout(() => {
                            this.popupClick = false;
                        }, 1000);
                    })

                    if (fit) {
                        marker.addTo(group);
                        this.cancelMoveEvent = true;
                    }
                }
            });

            if (fit) {
                this.map.fitBounds(group.getBounds());
            }
            this.$loader.hide();
        });
    }

    getMarkerText(obj, lastPopup) {
        let url = this.$map.attr("data-initiative-detail-url");
        let anchor = "<a target='_blank' href='" + url.replace("abc", obj.id) + "'>" + obj.title + "</a><br>"

        if (!lastPopup) {
            return obj.name + "<br>" + anchor;
        }
        else {
            return lastPopup + anchor;
        }
    }
}

export default Map;